import { render } from "./MyEvents.vue?vue&type=template&id=4902f126"
import script from "./MyEvents.vue?vue&type=script&lang=js"
export * from "./MyEvents.vue?vue&type=script&lang=js"

import "./MyEvents.vue?vue&type=style&index=0&id=4902f126&lang=less"
script.render = render

export default script